import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import MantNivelAprobacion from "./components/MantNivelAprobacion";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import List from "../../global/content/List";
import RolPorNivelAprobacionModal from "../../global/modals/RolPorNivelAprobacionModal";
const MySwal = withReactContent(Swal);

const PageNivelAprobacion = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [page, setPage] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [pages, setPages] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [limit, setLimit] = useState(CONFIGURACIONES.INIT.LIMIT_PAGE);
    const [param, setParam] = useState(CONFIGURACIONES.INIT.STRING);
    const [dataList, setDataList] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [nivelesAprobacion, setNivelesAprobacion] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [endPointShow, setEndPointShow] = useState(CONFIGURACIONES.INIT.STRING);
    const [endPointUpdate, setEndPointUpdate] = useState(CONFIGURACIONES.INIT.STRING);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [showRolPorNivelAprobacion, setShowRolPorNivelAprobacion] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [detallePorNivel, setDetallePorNivel] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [selectRoles, setSelectRoles] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [refId, setRefId] = useState(CONFIGURACIONES.INIT.STRING);
    
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
   

    const createComponent = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        console.log(`${CONFIGURACIONES.SITES.NIVEL_DE_APROB}/new`);
        
        navigate(`${CONFIGURACIONES.SITES.NIVEL_DE_APROB}/new`);
    };

    const editComponent = (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        setEndPointShow(param.links.find(link => link.rel === CONFIGURACIONES.REFS.SELF)?.href || null);
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        navigate(`/view/niveles-de-aprobacion/${param.id}`);
    };

    const deleteComponent = async (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)) { return; }
        let endPointDelete = param.links.find(link => link.rel === CONFIGURACIONES.REFS.DELETE)?.href || null;
        // console.log('endpoint', endPointDelete); 
        await Functions().deleteElement(endPointDelete, CONFIGURACIONES.MESSAGES.SUCCESS_DELETE_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.NIVELES_DE_APROBACION} <strong>${param.nombre}</strong>`,  getUser(), loadData, {})
    };

    const closeSection = () => {
        setParam(CONFIGURACIONES.INIT.STRING);
        setPage(CONFIGURACIONES.INIT.CURRENT_PAGE);
        setLimit(CONFIGURACIONES.INIT.LIMIT_PAGE);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        navigate(`${CONFIGURACIONES.SITES.NIVEL_DE_APROB}`);
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const createDataComponent = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().save(CONFIGURACIONES.ENDPOINTS.NIVELES_DE_APROBACION, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), closeSection, form);
    };

    const saveRolesPorNivel = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.APROBACION_CREDITOS)) { return; }
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.NIVELES_DE_APROBACION}/${refId}/rol-por-nivel-aprobacion`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), closeRolPorNivelAprobacion, form);
    };

    const updateComponent = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        await Functions().update(endPointUpdate, CONFIGURACIONES.MESSAGES.SUCCESS_UPDATE_OPERATION, getUser(), closeSection, form);
    }

    const initData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.NIVELES_DE_APROBACION}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setNivelesAprobacion(rpta.data.nivelesAprobacion);
            }
        });
    }
    const loadData = () => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.NIVELES_DE_APROBACION}?param=${param}&page=${page}&limit=${limit}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataList(rpta.data);
                setPages(rpta.pagination.pages);
            }
        });
    };

    const loadDataInitModal = (param) => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.NIVELES_DE_APROBACION}/util/${param.id}/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDetallePorNivel(rpta.data.detalles);
                setSelectRoles(rpta.data.cargos);
            }
        });
    }

    const fnApprobal = (param) => {
        setRefId(param.id);
        loadDataInitModal(param);
        setShowRolPorNivelAprobacion(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const closeRolPorNivelAprobacion = () => {
        setShowRolPorNivelAprobacion(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        let search = localStorage.getItem('search');
        console.log('search', search);
        
        if (!search) {
            showSpinnerLoader();
        }
        localStorage.removeItem('search');
        // loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        } else {
            loadData();
        }
    }, [location.pathname, page, param, limit])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (<div className="col-md-12 col-xs-12">
                        <div className="card">
                            <div className="card-body">
                                <List icon={iconActive} title={'Niveles de Aprobación'} headers={CONFIGURACIONES.TABLES.HEADERS.NIVELES_DE_APROBACION} data={dataList} fnCreate={createComponent} fnEdit={editComponent} fnDelete={deleteComponent} setPage={setPage} pages={pages} page={page} 
                                    setParam={setParam} entityPagination={'nivel_aprobacion'} setLimit={setLimit} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)}
                                    showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} dataTooltipId={'create_nivel_aprobacion'} content={'Crear Nivel de Aprobación'}
                                    showLevelsAprobation={searchPermissions(CONFIGURACIONES.ACTIONS.APROBACION_CREDITOS)} fnApprobal={fnApprobal} />
                            </div>
                        </div>
                    </div>)}

                    {!isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantNivelAprobacion mant={'Nivel de Aprobación'} idEdit={idRef} closeSection={closeSection} MySwal={MySwal} idRef={idRef} setIdRef={setIdRef} createData={createDataComponent} updateData={updateComponent} endPointShow={endPointShow} setEndPointUpdate={setEndPointUpdate} nivelesAprobacion={nivelesAprobacion} init={initData} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)}
                                        />
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
            <RolPorNivelAprobacionModal show={showRolPorNivelAprobacion} onClose={closeRolPorNivelAprobacion} 
            title={"Gestión de Roles por Nivel"} selectRoles={selectRoles} detalles={detallePorNivel} onSave={saveRolesPorNivel} showLevelsAprobation={searchPermissions(CONFIGURACIONES.ACTIONS.APROBACION_CREDITOS)} />
        </div>
    )
}

export default PageNivelAprobacion;